import { z } from "zod";

// t("PENDING")
// t("RECEIVED")
export const purchaseOrderItemStatusEnum = z.enum(["PENDING", "RECEIVED"]);

export type PurchaseOrderItemStatus = z.infer<
  typeof purchaseOrderItemStatusEnum
>;
